import React from "react";

import { Article } from "@/custom-types/Wordpress";

import AuthorBox from "@/components/news/AuthorBox";
import BrandBox from "@/components/news/BrandBox";

const NewsArticleFooter: React.FC<{
  article: Article;
}> = ({ article }) =>
  article.brand?.name ? (
    <BrandBox brand={article.brand} />
  ) : (
    <AuthorBox author={article.author} />
  );

export default NewsArticleFooter;
